<template>
    <div class="container-principal">               
        <div class="form">
            <span class="titulo-filtros-cabecalho">
                <i class="carregar pi pi-spin pi-sync"></i>
            </span>
        </div>
    </div>
</template>

<script>
import SSO from './SSO.js'
export default SSO
</script>

<style scoped>

.carregar{
    font-size: 77px;
    padding: 15px;
}


.container-principal {
height: 100%;
width: 100%;
display: flex;
align-items: center;
justify-content: center;
background-image: url(@/assets/imgs/fundo_retangulos.svg);
background-size: 100%;
background-position: center;
}


.form {
display: flex;
flex-direction: column;
gap: 20px;
justify-content: center;
align-items: center;
grid-area: form;
}


@media (min-width:461px) {
.container-principal{
    background: url(@/assets/imgs/Fundo_login_1.svg) no-repeat top left,
    url(@/assets/imgs/Fundo_login_2.svg) no-repeat bottom right;

        background-size: 100%;
background-position: center;

}

}

@media (min-width:600px) {
    .container-principal{
    background: url(@/assets/imgs/Fundo_login_1.svg) no-repeat top left,
    url(@/assets/imgs/Fundo_login_2.svg) no-repeat bottom right;

        background-size: 100%;
background-position: center;

}

}

@media (min-width:1025px) {
.container-principal{
    background: url(@/assets/imgs/Fundo_login_1.svg) no-repeat top left,
    url(@/assets/imgs/Fundo_login_2.svg) no-repeat bottom right;

        background-size: 100%;
background-position: center;

}
}

@media (min-width:1500px) {
.container-login {
height: 100%;
min-height: 380px;
align-items: center;
margin-top: 46px;
gap: 5px;
display: grid;
grid-template-columns: 1fr;
grid-template-rows: 38% 23% 39%;
grid-auto-flow: row;
grid-template-areas:
    "logo"
    "form"
    "botoes";
}

}
</style>